package com.veldekar.components.srd.spells

import androidx.compose.runtime.Composable
import com.veldekar.components.srd.SpellComponent
import com.veldekar.components.srd.SpellMetadata

@Composable
public fun PolymorphMetadata() {
    SpellMetadata(
        spellIndex = "polymorph",
        castingTime = "1 action",
        range = "60 feet",
        components = listOf(SpellComponent.VERBAL, SpellComponent.SOMATIC, SpellComponent.MATERIAL),
        material = "A caterpillar cocoon.",
        duration = "Up to 1 hour",
        damageBase = null,
        damageScaling = null,
        savingThrow = "WIS (None)",
        aoe = null,
        concentration = true
    )
}
